import { jsxs as w, jsx as a } from "react/jsx-runtime";
import { forwardRef as T, useState as F, useRef as U, useEffect as h } from "react";
import k from "./convertFileToDataURI.js";
import { tv as H } from "tailwind-variants";
import L from "./Icon.js";
const v = H({
  slots: {
    imageWrapper: [
      "bg-transparent",
      "border-neutral-300",
      "border-dashed",
      "border-2",
      "cursor-pointer",
      "flex",
      "items-center",
      "justify-center",
      "overflow-hidden",
      "relative",
      "rounded-lg",
      "peer-focus:outline-dotted",
      "peer-focus:outline-[3px]",
      "peer-focus:outline-cyan-500"
    ],
    innerWrapper: ["relative"],
    wrapper: ["flex", "flex-wrap-reverse", "items-center", "gap-3"]
  },
  variants: {
    isRounded: {
      true: {
        imageWrapper: ["rounded-full"]
      }
    },
    isDisabled: {
      true: {
        wrapper: ["opacity-50"],
        imageWrapper: ["cursor-not-allowed"]
      }
    },
    size: {
      sm: {
        imageWrapper: ["h-[6rem]", "w-[6rem]"]
      },
      md: {
        imageWrapper: ["h-[12rem]", "w-[12rem]"]
      },
      lg: {
        imageWrapper: ["h-[18rem]", "w-[18rem]"]
      },
      full: {
        imageWrapper: ["h-[18rem]", "w-full"],
        innerWrapper: ["w-full"]
      }
    }
  },
  compoundVariants: [
    {
      labelIsHidden: !0,
      hasHelperText: !1,
      class: {
        wrapper: ["gap-0"]
      }
    }
  ]
}), { wrapper: E, imageWrapper: O, innerWrapper: P } = v(), y = T(
  ({
    accept: W = "image/*",
    ariaDescribedby: x,
    ariaLabel: b,
    defaultValue: D,
    disabled: t,
    id: N,
    isRounded: R,
    name: I,
    onBlur: j,
    onChange: p,
    size: c = "md",
    value: r
  }, i) => {
    const [s, d] = F(D), l = U(), u = async (e) => {
      var f, g;
      const [m] = e.target.files || e.dataTransfer.files, n = m ? await k(m) : (f = e.dataTransfer) == null ? void 0 : f.getData("text/uri-list");
      if (!n) return;
      const o = (g = n.match(/data:(.+);base64/)) == null ? void 0 : g[1];
      o != null && o.startsWith("image") && (d(n), p == null || p(n));
    };
    return h(() => {
      i == null || i({ focus: () => l.current.focus() });
    }, [i]), h(() => {
      r !== void 0 && r !== s && (d(r), r || (l.current.value = ""));
    }, [r]), /* @__PURE__ */ w("div", { className: E({ isDisabled: t }), children: [
      /* @__PURE__ */ w("div", { className: P({ size: c }), children: [
        /* @__PURE__ */ a(
          "input",
          {
            "aria-describedby": x,
            "aria-label": b,
            accept: W,
            className: "peer sr-only",
            disabled: t,
            id: N,
            onChange: u,
            ref: l,
            type: "file"
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            "aria-hidden": !0,
            "data-testid": "image-wrapper",
            className: O({ isRounded: R, size: c }),
            onBlur: j,
            onClick: () => l.current.click(),
            onDragOver: t ? void 0 : (e) => e.preventDefault(),
            onDrop: t ? void 0 : (e) => {
              e.preventDefault(), u(e);
            },
            children: s ? /* @__PURE__ */ a(
              "img",
              {
                alt: "Preview",
                className: "h-full object-cover w-full",
                src: s
              }
            ) : /* @__PURE__ */ a(
              L,
              {
                className: "text-neutral-500 text-lg",
                name: "file-circle-plus",
                style: "solid"
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ a("input", { name: I, type: "hidden", value: s || "" })
    ] });
  }
);
y.displayName = "ImageField";
y.styles = v;
export {
  y as default
};
